import React, { Component, Fragment } from 'react'
import { css, StyleSheet } from 'aphrodite';
import { Product } from '../../common/components/catalog/Product';

export class ProductCustom extends Product {
}